import React from 'react';
import '../../App.css';
import '../final-cta/finalCTAWrapp.css';
import { Link } from 'react-router-dom';


function FinalCTAWrapp({data}) {
  return (
    <section className="finalcta">
        <div className="container">
            {data.readycolumn1 && (
          <div dangerouslySetInnerHTML={{ __html: data.readycolumn1 }}></div>
        )}

            <div className="button-cover">
              <Link to="/registerPage">
  <button className="reg-btn">{data.readycolumn2}</button>
</Link>

             <Link to="/loginPage">
  <button className="login-btn1">{data.readycolumn3}</button>
</Link>

            </div>
        </div>
    </section>
  )
}

export default FinalCTAWrapp
